import React, { useState } from 'react';
import {
  useDataProvider,
  useNotify,
  useRedirect,
  useRefresh,
} from 'react-admin';
import { CustomerCreateDialog } from './CustomerCreateDialog';

interface ConvertLeadDialogProps {
  open: boolean;
  onClose: () => void;
  leadRecord: any;
}

export const ConvertLeadDialog: React.FC<ConvertLeadDialogProps> = ({
  open,
  onClose,
  leadRecord,
}) => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const redirect = useRedirect();
  const refresh = useRefresh();

  // Prepare initial values for customer creation from lead data
  const getInitialCustomerValues = () => {
    if (!leadRecord) return {};

    // Generate a smart display name
    const nameParts = [leadRecord.firstName, leadRecord.lastName].filter(Boolean);
    const name = nameParts.join(' ');
    let displayName = leadRecord.displayName || name || leadRecord.company || '';
    
    // If we have both name and company, combine them
    if (name && leadRecord.company && !leadRecord.displayName) {
      displayName = `${name} - ${leadRecord.company}`;
    }

    return {
      displayName,
      firstName: leadRecord.firstName || '',
      lastName: leadRecord.lastName || '',
      title: leadRecord.title || '',
      company: leadRecord.company || '',
      email: leadRecord.email || '',
      phone: leadRecord.phone || '',
      notes: leadRecord.notes || '',
      customerTypeId: leadRecord.customerTypeId || '',
      // Note: zoneId will be added by the user during conversion
    };
  };

  const handleCustomerCreated = async (customer: any) => {
    try {
      // Update the lead to mark it as converted
      await dataProvider.update('crm/leads', {
        id: leadRecord.id,
        data: {
          status: 'Converted',
          convertedCustomerId: customer.id,
        },
      });

      notify('Lead successfully converted to customer!', { type: 'success' });
      refresh();
      redirect(`/customers/${customer.id}/show`);
    } catch (error) {
      notify('Failed to update lead status', { type: 'error' });
      console.error('Error updating lead:', error);
    }
  };

  return (
    <CustomerCreateDialog
      open={open}
      onClose={onClose}
      initialValues={getInitialCustomerValues()}
      onSuccess={handleCustomerCreated}
    />
  );
};